import get from 'lodash/get';
import map from 'lodash/map';
import { change, getFormValues } from 'redux-form';
import { push } from 'react-router-redux';

import { FORM_NAME } from './consts';

const getFirstId = collection => get(collection, '0.id', null);

export const FETCH_TERMS_SUCCESS = 'FETCH_TERMS_SUCCESS';
export const FETCH_TERMS_FAIL = 'FETCH_TERMS_FAIL';
export const fetchTermsForPackage = packageId => async (dispatch, getState) => {
  if (!packageId) {
    return;
  }

  try {
    const terms = await fetch(`/package/${packageId}/terms`);
    const { TermId } = getFormValues(FORM_NAME)(getState());

    dispatch({
      type: FETCH_TERMS_SUCCESS,
      payload: {
        terms,
      },
    });

    if (!map(terms, 'id').includes(TermId)) {
      dispatch(change(FORM_NAME, 'TermId', getFirstId(terms)));
    }
  } catch (error) {
    dispatch({
      type: FETCH_TERMS_FAIL,
      payload: {
        error,
      },
    });
  }
};

export const FETCH_PACKAGES_SUCCESS = 'FETCH_PACKAGES_SUCCESS';
export const FETCH_PACKAGES_FAIL = 'FETCH_PACKAGES_FAIL';
export const fetchPackages = () => async (dispatch, getState) => {
  try {
    const packages = await fetch('/provider/plan-types');

    dispatch({
      type: FETCH_PACKAGES_SUCCESS,
      payload: {
        packages,
      },
    });

    const { PackageId = getFirstId(packages) } = getFormValues(FORM_NAME)(
      getState(),
    );
    await dispatch(fetchTermsForPackage(PackageId));
  } catch (error) {
    dispatch({
      type: FETCH_PACKAGES_FAIL,
      payload: {
        error,
      },
    });
  }
};

export const redirect = to => dispatch => dispatch(push(to));
